import google from 'assets/img/nav-icons/google.png';
import githubLight from 'assets/img/nav-icons/github-light.png';
import account from 'assets/img/team/3.jpg';
import linkedin from 'assets/img/nav-icons/linkedin.png';
import twitter from 'assets/img/nav-icons/twitter.png';
import facebook from 'assets/img/nav-icons/facebook.png';
import instagram from 'assets/img/nav-icons/instagram.png';
import pinterest from 'assets/img/nav-icons/pinterest.png';
import slack from 'assets/img/nav-icons/slack.png';

export const quickLinks = [
  {
    avatar: account,
    title: 'Account',
    link: `/user/profile`
  },
  { img: google, title: 'Google', link: 'https://google.com/' },
  { img: githubLight, title: 'Github', link: 'https://github.com/' },
  { hr: true },
  { img: linkedin, title: 'Linkedin', link: 'https://github.com/' },
  { img: twitter, title: 'Twitter', link: 'https://twitter.com/' },
  { img: facebook, title: 'Facebook', link: 'https://facebook.com/' },
  { img: instagram, title: 'Instagram', link: 'https://instagram.com/' },
  { img: pinterest, title: 'Pinterest', link: 'https://pinterest.com/' },
  { img: slack, title: 'Slack', link: 'https://slack.com/' }
  // {
  //   avatarText: 'E',
  //   title: 'Events',
  //   link: `/events/event-detail`,
  //   contentClass: 'bg-primary-subtle text-primary'
  // }
];
